import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IContract, Contract } from "@/models/contract.entity";

export const FleetContractDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IContract> {
  protected mapEntity(entity: IContract): IContract {
    return new Contract(entity);
  }

  getIdentifier(entity: IContract): string {
    return entity.id;
  }
})();
